import React, { createContext, useContext, useEffect, useState } from 'react';

// Lets a page inject its own controls / title into the shared top navbar
// (Navbaar), so pages don't need a second header row of their own.
const NavbarActionsContext = createContext({
    actions: null, setActions: () => {},
    title: null, setTitle: () => {},
});

export const NavbarActionsProvider = ({ children }) => {
    const [actions, setActions] = useState(null);
    const [title, setTitle] = useState(null); // { title, subtitle } | null
    return (
        <NavbarActionsContext.Provider value={{ actions, setActions, title, setTitle }}>
            {children}
        </NavbarActionsContext.Provider>
    );
};

// Page hook — renders `node` into the navbar while the page is mounted.
// Pass the state it depends on as `deps` so it refreshes (e.g. search text).
export const useNavbarActions = (node, deps = []) => {
    const { setActions } = useContext(NavbarActionsContext);
    useEffect(() => {
        setActions(node);
        return () => setActions(null);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
};

// Page hook — overrides the navbar title/subtitle for routes that aren't in
// PAGE_META (e.g. dynamic detail pages). `meta` is { title, subtitle }.
export const useNavbarTitle = (meta, deps = []) => {
    const { setTitle } = useContext(NavbarActionsContext);
    useEffect(() => {
        setTitle(meta);
        return () => setTitle(null);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
};

// Consumed by Navbaar to render whatever the active page registered.
export const useNavbarActionsValue = () => useContext(NavbarActionsContext).actions;
export const useNavbarTitleValue = () => useContext(NavbarActionsContext).title;

export default NavbarActionsContext;
